<div class="fullsize-vbox">
    <wj-flex-grid #grid (initialized)="onGridInitialized(grid)"
                  [showSelectedHeaders]="Wijmo.HeadersVisibility.All" [itemsSource]="[]"
                  [showMarquee]="true" width="100%" height="100%"
                  [allowResizing]="Wijmo.AllowResizing.Both" [autoRowHeights]="false" [quickAutoSize]="false"
                  [headersVisibility]="Wijmo.HeadersVisibility.All" [selectionMode]="Wijmo.SelectionMode.MultiRange" [isReadOnly]="true"
                  [autoGenerateColumns]="false"
    >
        <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
    </wj-flex-grid>
</div>
